/**
 * Детерминированные hex для буквенных аватаров (профиль, переключатель аккаунтов).
 * Значения совпадают с light-темой `markbase-design-system/tokens.css`:
 * brand, info, brand-light, ok, accent, warn, waygpt-brand, err.
 *
 * Next-модули (markbase.ru/modouls/…/frontend) держат зеркальную копию в `src/lib/avatarDiscriminationHex.js`
 * (turbopack не собирает импорты из соседнего `frontend/`). Менять палитру — править канон здесь и все зеркала.
 */
export const AVATAR_DISCRIMINATION_HEX = [
  '#0284C7', // --brand
  '#3B82F6', // --info
  '#06B6D4', // --brand-light
  '#10B981', // --ok
  '#EA580C', // --accent
  '#F59E0B', // --warn
  '#722ed1', // --waygpt-brand
  '#EF4444', // --err
];

/**
 * @param {string} [str] email или другой стабильный ключ
 * @returns {string}
 */
export function pickAvatarDiscriminationHex(str) {
  let hash = 0;
  for (let i = 0; i < (str || '').length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_DISCRIMINATION_HEX[Math.abs(hash) % AVATAR_DISCRIMINATION_HEX.length];
}
